import { QueryClient, useQuery } from '@tanstack/react-query';
import request from '@utils/request';
import { SpaPackageType } from 'shared-types/SpaPackage';

export function useGetSpaPackage(
  propertyId: number,
  spaPackageId: number,
  language: string,
  isNonWebPackage?: boolean,
  date?: string,
  enabled = true
) {
  return useQuery({
    queryKey: getSpaPackageKey(propertyId, spaPackageId, language, isNonWebPackage, date),
    queryFn: () => getSpaPackage(propertyId, spaPackageId, language, isNonWebPackage, date),
    staleTime: Infinity,
    cacheTime: Infinity,
    enabled: !!spaPackageId && enabled,
    keepPreviousData: true,
  });
}

export async function getSpaPackage(
  propertyId: number,
  spaPackageId: number,
  language: string,
  isNonWebPackage?: boolean,
  date?: string
) {
  const url = `${propertyId}/spa-packages/${spaPackageId}/${language}`;
  const params: Record<string, any> = {};
  if (isNonWebPackage) {
    params['allow-non-web-packages'] = 1;
  }
  if (date) {
    params['date'] = date;
  }
  const { data } = await request.get(url, {
    isPayloadCaseConverterDisabled: true,
    params,
  });
  return data as SpaPackageType;
}

export const getSpaPackageKey = (
  propertyId: number,
  spaPackageId: number,
  language: string,
  isNonWebPackage?: boolean,
  date?: string
) => ['spaPackage', propertyId, spaPackageId, language, isNonWebPackage, date];

export const getSpaPackagePrefetch = (
  queryClient: QueryClient,
  propertyId: number,
  spaPackageId: number,
  language: string
) =>
  queryClient.prefetchQuery(
    getSpaPackageKey(propertyId, spaPackageId, language),
    () => getSpaPackage(propertyId, spaPackageId, language),
    { staleTime: Infinity, cacheTime: Infinity }
  );
